import React from 'react';

/**
 * FinalCTA — final call to action with funnel entry. Auto-numbered when
 * inside `.numbered-sections`. Pass `onStartFunnel` and optionally `formRef`.
 */
export default function FinalCTA({ onStartFunnel, formRef }) {
  return (
    <section id="form" style={{ padding: '140px 0', background: 'var(--cream-deep)' }} ref={formRef}>
      <div className="shell">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 340px) 1fr',
            gap: 80,
            alignItems: 'start',
          }}
        >
          <div className="reveal">
            <div className="section-label numbered" style={{ marginBottom: 28 }}>
              <span>Anfrage</span>
            </div>
            <h2 className="h-section" style={{ marginBottom: 28 }}>
              Bereit für Ihre Erstanalyse?
            </h2>
            <div style={{ paddingTop: 24, borderTop: '1px solid var(--cream-line)' }}>
              <div className="eyebrow" style={{ marginBottom: 12 }}>Erstanalyse</div>
              <p className="muted" style={{ fontSize: 14, lineHeight: 1.6 }}>
                Kostenlos · unverbindlich
              </p>
            </div>
          </div>

          <div className="reveal" style={{ paddingTop: 43 }}>
            <p
              className="body-prose"
              style={{
                fontSize: 17,
                color: 'var(--charcoal-muted)',
                paddingTop: 13,
                marginBottom: 36,
                maxWidth: '48ch',
              }}
            >
              Fordern Sie Ihre kostenlose, unverbindliche Erstanalyse an — wir melden uns mit einer ersten Einschätzung Ihres Portfolios.
            </p>
            <button
              type="button"
              onClick={onStartFunnel}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                padding: '16px 32px',
                background: 'var(--bordeaux)',
                color: 'var(--cream)',
                fontFamily: 'var(--grotesk)',
                fontSize: 14,
                letterSpacing: '0.08em',
                fontWeight: 500,
                border: '1px solid var(--bordeaux)',
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'background 200ms ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bordeaux-soft)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bordeaux)'; }}
            >
              Erstanalyse starten <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
